import React from 'react'
import { Card } from 'primereact/card';
import { Col, Row, } from 'reactstrap'
import DocumentosContrato from './DocumentosContrato';
import Laudos from './Laudos';
import Aditivos from './Aditivos';
import Contrato from './Contrato'
import OrdensServico from './OrdensServico';

function ContratoContainer ( props ){ 

    const { aditivos, documentos, laudos, ordensServico} = props.value

    return(
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <Contrato value={props.value} />
                </Col>
            </Row>
            
            <Row>
                <Col md={12}>
                    <Card title="Documentação">
                        <DocumentosContrato documentos={documentos} />
                    </Card>
                </Col>
            </Row>  


            <Row>
                <Col md={12}>
                    <Card title="Laudos">
                        <Laudos laudos={laudos} />
                    </Card>
                </Col>
            </Row>  

            <Row>
                <Col md={12}>
                    <Card title="Ordens de Serviço">
                        <OrdensServico list={ordensServico} />
                    </Card>
                </Col>
            </Row> 

            <Row>
                <Col md={12}>
                    <Card title="Aditivos">
                        <Aditivos aditivos={aditivos} />
                    </Card>
                </Col>
            </Row>  
        </React.Fragment>
            
    )
 }


 export default ContratoContainer